import React, { useContext } from 'react';
import Link from '../../../components/common/link/link';
import { transformRelativeUrlValidateRoot } from '../../../components/utils/router-util/router-util';
import ServerContext from '../../../contexts/serverContext';
import './recent-recalls-links.scss';
import { FMMastheadContent } from '../../../views/fm-home-page/hooks/use-fm-masthead-content';

interface RecentRecallsLinksProps {
    recentRecallsLinksData: FMMastheadContent;
}

export const RecentRecallsLinks = (props: RecentRecallsLinksProps) => {
    const context = useContext(ServerContext);

    return (
        <>
            {props.recentRecallsLinksData.relatedCategoryLinksTitle && (
                <div className="recent-recalls-container">
                    <h2 className="recent-recalls-title">
                        {props.recentRecallsLinksData.popularLinksSubTitle}
                    </h2>
                    <div className="recent-recalls-links-container">
                        <div className="safety-recalls" tabIndex={0}>
                            {props.recentRecallsLinksData
                                .relatedCategoryLinksTitle && (
                                <h3 className="recalls-title">
                                    {
                                        props.recentRecallsLinksData
                                            .relatedCategoryLinksTitle
                                    }
                                </h3>
                            )}
                            {props.recentRecallsLinksData.relatedCategoryLinksItems
                                .slice(0, 5)
                                .map(recentSafetyRecallsLinkItem => (
                                    <h3
                                        key={`${recentSafetyRecallsLinkItem.title}`}
                                        className="recalls-link"
                                    >
                                        <Link
                                            href={transformRelativeUrlValidateRoot(
                                                recentSafetyRecallsLinkItem.url,
                                                context.root
                                            )}
                                            target={
                                                recentSafetyRecallsLinkItem.targetBlank
                                                    ? '_blank'
                                                    : ''
                                            }
                                        >
                                            {recentSafetyRecallsLinkItem.title}
                                        </Link>
                                    </h3>
                                ))}
                        </div>
                        <div className="compliance-recalls" tabIndex={0}>
                            {props.recentRecallsLinksData.popularLinksTitle && (
                                <h3 className="recalls-title">
                                    {
                                        props.recentRecallsLinksData
                                            .popularLinksTitle
                                    }
                                </h3>
                            )}
                            {props.recentRecallsLinksData.popularLinksItems
                                .slice(0, 5)
                                .map(recentComplianceRecallsLinkItem => (
                                    <h3
                                        key={`${recentComplianceRecallsLinkItem.title}`}
                                        className="recalls-link"
                                    >
                                        <Link
                                            href={transformRelativeUrlValidateRoot(
                                                recentComplianceRecallsLinkItem.url,
                                                context.root
                                            )}
                                            target={
                                                recentComplianceRecallsLinkItem.targetBlank
                                                    ? '_blank'
                                                    : ''
                                            }
                                        >
                                            {
                                                recentComplianceRecallsLinkItem.title
                                            }
                                        </Link>
                                    </h3>
                                ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
